import { render, staticRenderFns } from "./UpdatePasswordCard.vue?vue&type=template&id=a3d309fa"
import script from "./UpdatePasswordCard.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports